import React from 'react'
import { Button } from '@material-ui/core'

import { SSPX } from 'constants/themeConstants'
import { DEFAULT_FONT_SIZE, MAIN_FONT_FAMILY } from 'constants/textConstants'
import styled from 'styles/styled'

type Props = {
	children: string
	className?: string
	startIcon?: React.ReactNode
	onClick?: () => void
}

const ResponseButton = ({ onClick, children, className, ...rest }: Props) => (
	<Button variant="contained" disableElevation onClick={onClick} className={className} {...rest}>
		{children}
	</Button>
)

const WidgetButton = styled(ResponseButton)`
	&& {
		font-family: ${MAIN_FONT_FAMILY};
		font-size: ${DEFAULT_FONT_SIZE};
		color: ${props => props.theme.darkVariant};
		margin: ${0.5 * SSPX}px;
		font-weight: 400;
		border: 1px solid ${props => props.theme.darkVariant};
		border-radius: 10px;
		padding: 10px 13px;
		background-color: white;
		text-transform: none;
		&:hover {
			transition: all 0.1s ease 0s;
			background-image: linear-gradient(
				80deg,
				${props => props.theme.darkVariant},
				${props => props.theme.lightVariant} 130%
			);
			color: white;
			border-color: white;
		}
	}
`
export default WidgetButton
